appSocial.component('tradedAssets', {
    templateUrl: 'widgets/leader-detail/components/traded-assets/TradedAssetsComponent.html',
    bindings: {
        trader: '<',
    },
    controller: [
        'SocialUtils',
        'SocialTypes',
        'SocialAPIService',
        'SocialConstants',
        'SocialLocaleService',
        'TradeAggregated',
        class TradedAssetsComponent {
            constructor(
                SocialUtils,
                SocialTypes,
                SocialAPIService,
                SocialConstants,
                SocialLocaleService,
                TradeAggregated
            ) {
                /**
                 * @type {SocialUtils}
                 */
                this.utils = SocialUtils;

                /**
                 * @type {SocialAPIService}
                 */
                this.api = SocialAPIService;

                this.constants = SocialConstants;

                this.translation = SocialLocaleService.translation;

                this.types = SocialTypes;

                this.tradedAssetFactory = (data) => new TradeAggregated(this.trader, data);

                this.trades = [];
            }

            $onInit() {
                this.getAssets();
            }

            $onChanges(changes) {

            }

            $onDestroy() {

            }

            getAssets() {
                const request = {
                    _url: '/' + this.trader.id,
                    open: false,
                    limit: 12
                }

                return this.api.request.getAggregatedTrades(request)
                    .then((response) => {
                        this.trades = response.trades
                            .filter(item => !(['Correction']).includes(item.symbol))
                            .map(item => this.tradedAssetFactory(item));
                    })
            }

        }]
})
